import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { gettext, interpolate } from 'common/language'
import AlbumGalleryCard from 'common/widgets/blocks/AlbumGalleryCard'
import Container from 'common/widgets/Container'


SinglePageDescriptionView.propTypes = {
  schoolName: PropTypes.string.isRequired,
  schoolDescription: PropTypes.string.isRequired,
  schoolImages: PropTypes.array.isRequired,
}

export default function SinglePageDescriptionView({ schoolName, schoolDescription, schoolImages }) {
  const data = useMemo(() => ({
    heading: interpolate(gettext('Why %s'), [schoolName]),
    heading_level: '2',
    text: schoolDescription,
    images: schoolImages.slice(1),
  }), [schoolName, schoolDescription, schoolImages])

  return (
    <Container size="xl">
      <AlbumGalleryCard data={data} isContainer />
    </Container>
  )
}
